import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const services = [
    {
      title: 'Business Consulting',
      description: 'Strategic guidance to help your business navigate challenges and seize opportunities with confidence.',
      icon: 'ri-lightbulb-line',
      color: 'bg-gradient-to-br from-[#E0F2FE] to-[#BAE6FD]',
    },
    {
      title: 'Digital Solutions',
      description: 'Cutting-edge technology implementations that transform your operations and enhance customer experiences.',
      icon: 'ri-code-s-slash-line',
      color: 'bg-gradient-to-br from-[#CCFBF1] to-[#99F6E4]',
    },
    {
      title: 'Growth Strategy',
      description: 'Data-driven strategies designed to accelerate your business growth and maximize market potential.',
      icon: 'ri-line-chart-line',
      color: 'bg-gradient-to-br from-[#E9D5FF] to-[#D8B4FE]',
    },
  ];

  const stats = [
    { number: '500+', label: 'Projects Completed', description: 'Successfully delivered' },
    { number: '98%', label: 'Client Satisfaction', description: 'Consistently rated' },
    { number: '50+', label: 'Industries Served', description: 'Diverse expertise' },
  ];

  const clients = [
    'https://public.readdy.ai/ai/img_res/e1840752751bb47a2db744c656e02c5e.jpg',
    'https://readdy.ai/api/search-image?query=financial%20services%20company%20logo%20design%20professional%20minimalist%20clean%20white%20background%20corporate%20brand%20identity%20elegant%20typography&width=180&height=80&seq=client2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=healthcare%20company%20logo%20design%20modern%20professional%20clean%20white%20background%20corporate%20brand%20identity%20medical%20cross%20symbol&width=180&height=80&seq=client3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=retail%20business%20company%20logo%20design%20contemporary%20professional%20clean%20white%20background%20corporate%20brand%20identity%20shopping%20symbol&width=180&height=80&seq=client4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=manufacturing%20company%20logo%20design%20industrial%20professional%20clean%20white%20background%20corporate%20brand%20identity%20gear%20symbol&width=180&height=80&seq=client5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=education%20company%20logo%20design%20modern%20professional%20clean%20white%20background%20corporate%20brand%20identity%20book%20symbol&width=180&height=80&seq=client6&orientation=landscape',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20professional%20business%20office%20environment%20with%20abstract%20geometric%20patterns%20soft%20lighting%20contemporary%20workspace%20design%20clean%20minimalist%20aesthetic%20teal%20and%20navy%20blue%20color%20scheme%20sophisticated%20corporate%20atmosphere%20blurred%20background%20bokeh%20effect&width=1920&height=1080&seq=hero1&orientation=landscape"
            alt="Hero Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1E3A5F]/90 via-[#1E3A5F]/75 to-[#0D9488]/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-3xl">
            <div className="mb-6">
              <span className="text-[#14B8A6] text-xs uppercase tracking-widest font-semibold">
                PROFESSIONAL BUSINESS SOLUTIONS
              </span>
            </div>
            <h1 className="text-7xl font-bold text-white leading-tight mb-8">
              Transform Your Business with Expert Services
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed mb-12 max-w-2xl">
              Delivering innovative solutions tailored to your unique business challenges and driving sustainable growth.
            </p>
            <div className="flex items-center gap-5">
              <Link
                to="/services"
                className="px-10 py-4 bg-white text-[#1E3A5F] rounded-full font-semibold text-base hover:bg-gray-100 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
              >
                Explore Services
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
              <Link
                to="/contact"
                className="px-10 py-4 border-2 border-white text-white rounded-full font-semibold text-base hover:bg-white hover:text-[#1E3A5F] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Schedule Consultation
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="py-24 bg-gradient-to-br from-[#1E3A5F] via-[#1E3A5F] to-[#0D9488]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-bold text-white mb-6">
            Ready to Elevate Your Business?
          </h2>
          <p className="text-xl text-white/80 mb-12">
            Connect with our experts to discuss your unique requirements and discover how we can help you succeed.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-4 px-12 py-4 bg-white text-[#1E3A5F] rounded-full font-bold text-base hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Contact Us Today
            <div className="w-8 h-8 bg-[#14B8A6] rounded-full flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-sm"></i>
            </div>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}